module.exports = __webpack_public_path__ + "static/img/greenretreats_tg04.1b57ee7.jpg";